import ApiService from '@/services/api.service'
import type { ContactListParams, ContactForm } from '@/types/contact'

export default {
  index: (params: ContactListParams) => 
    ApiService().get(`/user/contacts`, { params }),

  show: (id: number | string) => 
    ApiService().get(`/user/contacts/${id}`),

  store: (data: ContactForm) => 
    ApiService().post(`/user/contacts`, data),

  update: (id: number | string, data: ContactForm) => 
    ApiService().put(`/user/contacts/${id}`, data),

  destroy: (id: number | string) => 
    ApiService().delete(`/user/contacts/${id}`),

  import: (file: File) => {
    const formData = new FormData()
    formData.append('file', file)
    return ApiService().post(`/user/contacts/import`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  }
}